
import { Injectable, InjectionToken, Inject, Injector} from '@angular/core';
import { OrganizationService } from 'src/app/service/organization-service';
import { User } from 'src/app/model/user';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { UserDao } from 'src/app/dao/user-dao';
import { LocationDao } from 'src/app/dao/location-dao';
import { Location } from 'src/app/model/location';

import { OrganizationDao } from 'src/app/dao/organization-dao';
import { Organization } from 'src/app/model/organization';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
const apiUrl = 'https://jsonplaceholder.typicode.com/posts/42';

@Injectable({
    providedIn: 'root'
})
export class OrganizationServiceImpl implements OrganizationService {
    userDao: UserDao = this.injector.get(UserDao);
    locationDao: LocationDao = this.injector.get(LocationDao);
    organizationDao: OrganizationDao = this.injector.get(OrganizationDao);
    
    constructor(private injector: Injector,private http:HttpClient) {}

    getOrganization(): any {
        return this.organizationDao.getOrganization();
    }

    getOrganizationList(): Observable<any> {
        return this.organizationDao.getOrganizationList();
    }
    
    addOrganization(organization): Observable<any> {
        return this.organizationDao.addOrganization(organization);
    }
    editOrganization(organization): Observable<any> {
        console.log(organization);
        return this.organizationDao.editOrganization(organization);
    }
    getUserAPI(user): Observable<any> {
        console.log(user);
        return this.locationDao.getUserAPI(user);
    }
    getTestUser(): Observable<any> {
        return this.locationDao.getTestUser();
    }
    login(user): Observable<any> {
        return this.locationDao.login(user).pipe(
            map(userWebResponse => {
                console.log(userWebResponse.success);
                if ( userWebResponse.success === true ) {
                    return new User(userWebResponse.data);
                }
                else {
                    return false;
                }
            })
        );
    }
    forgotpassword(user): Observable<any> {
        return this.locationDao.forgotpassword(user).pipe(
            map(userWebResponse => {
                console.log(userWebResponse.success);
                return  userWebResponse.success;
            })
        );
    }
    logout(user): Observable<any> {
        console.log(user);
        return this.locationDao.logout(user);
    }

    private handleError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
      
          // TODO: send the error to remote logging infrastructure
          console.error(error); // log to console instead
      
          // TODO: better job of transforming error for user consumption
          console.log(`${operation} failed: ${error.message}`);
      
          // Let the app keep running by returning an empty result.
          return of(result as T);
        };
      }

}

// export const UserServiceProvider = new InjectionToken(
//     'UserServiceProvider',
//     { providedIn: 'root', factory: () => new UserServiceImpl(@Inject(ENV) private environment) }
// );
